export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/chat": [9,[2]],
		"/chat/[chat]": [10,[2]],
		"/home": [11],
		"/join": [12],
		"/people": [13],
		"/settings/about": [14,[3]],
		"/settings/alerts": [15,[3]],
		"/settings/content": [16,[3]],
		"/settings/privacy": [17,[3]],
		"/settings/profile": [18,[3]],
		"/settings/relays": [19,[3]],
		"/settings/wallet": [20,[3]],
		"/spaces": [21,[4]],
		"/spaces/create": [36,[4]],
		"/spaces/[relay]": [22,[4,5]],
		"/spaces/[relay]/calendar": [24,[4,5]],
		"/spaces/[relay]/calendar/[address]": [25,[4,5]],
		"/spaces/[relay]/chat": [26,[4,5]],
		"/spaces/[relay]/classifieds": [27,[4,5]],
		"/spaces/[relay]/classifieds/[address]": [28,[4,5]],
		"/spaces/[relay]/goals": [29,[4,5]],
		"/spaces/[relay]/goals/[id]": [30,[4,5]],
		"/spaces/[relay]/polls": [31,[4,5]],
		"/spaces/[relay]/polls/[id]": [32,[4,5]],
		"/spaces/[relay]/recent": [33,[4,5]],
		"/spaces/[relay]/threads": [34,[4,5]],
		"/spaces/[relay]/threads/[id]": [35,[4,5]],
		"/spaces/[relay]/[h]": [23,[4,5,6]],
		"/[bech32]": [8]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';